import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess107232Status: 'idle',
    startProcess107232Error: undefined as any,
    loadUserParamsProcess107232Status: 'idle',
    loadUserParamsProcess107232Error: undefined as any,

    process107232List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess107232 = createAsyncThunk('process107232Slice/startProcess107232', async ({ process107232 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess107232/`,
        prepareData(process107232),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess107232Status } = getState().process107232Slice
        return startProcess107232Status !== 'pending'
    }
})

export const loadUserParamsProcess107232 = createAsyncThunk('process107232Slice/loadUserParamsProcess107232', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess107232/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess107232Status } = getState().process107232Slice
        return loadUserParamsProcess107232Status !== 'pending'
    }
})

const Process107232Slice = createSlice({
    name: 'process107232Slice',
    initialState,
    reducers: {
        resetstartProcess107232: (state) => {
            state.job = undefined
            state.startProcess107232Error = undefined
        },
        resetstartProcess107232Error: (state) => {
            state.startProcess107232Error = undefined
        },
        resetloadUserParamsProcess107232: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess107232Error = undefined
        },
        resetloadUserParamsProcess107232Error: (state) => {
            state.loadUserParamsProcess107232Error = undefined
        },
        removeFromProcess107232ListById: (state, action) => {
            state.process107232List = state.process107232List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess107232ListByIds: (state, action) => {
            state.process107232List = state.process107232List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process107232List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess107232Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process107232List = []
            state.startProcess107232Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess107232.pending, (state) => {
            state.startProcess107232Status = 'pending'
            state.startProcess107232Error = undefined
        })
        builder.addCase(startProcess107232.fulfilled, (state, action) => {
            state.startProcess107232Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess107232.rejected, (state, action) => {
            state.startProcess107232Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess107232Error = action.error.message
            } else {
                state.startProcess107232Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess107232.pending, (state) => {
            state.loadUserParamsProcess107232Status = 'pending'
            state.loadUserParamsProcess107232Error = undefined
        })
        builder.addCase(loadUserParamsProcess107232.fulfilled, (state, action) => {
            state.loadUserParamsProcess107232Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess107232.rejected, (state, action) => {
            state.loadUserParamsProcess107232Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess107232Error = action.error.message
            } else {
                state.loadUserParamsProcess107232Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess107232,
    resetstartProcess107232Error,
    resetloadUserParamsProcess107232,
    resetloadUserParamsProcess107232Error,
    removeFromProcess107232ListById,
    removeFromProcess107232ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process107232Slice.actions
export default Process107232Slice.reducer
